import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import StockOrderCreateForm from "./-form";
import { StockOrderCrumbs } from "./-crumbs";

export const Route = createFileRoute("/_private/_stock-360/stock-order/create")(
  {
    component: StockOrderCreatePage,
  },
);

function StockOrderCreatePage() {
  return (
    <div>
      <title>Create Stock Order - Legrande Health Portal</title>
      <StockOrderCrumbs canEdit={true} />

      <Card>
        <CardHeader>
          <CardTitle>Create Stock Order</CardTitle>
          <CardDescription>
            Select the approving entity and fulfiller for this order.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <StockOrderCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
